import React from 'react'
import cn from 'classnames'
import classes from '../../Table.module.scss'

export const HeaderCell = ({
  children,
  isSelected,
  spacing = 4,
}: {
  children: React.ReactNode
  isSelected?: boolean
  spacing?: number
}) => (
  <div
    role='cell'
    className={cn(
      `col-${spacing}`,
      'd-flex justify-content-center align-items-center mc-text--center',
      {
        [classes.selected]: isSelected,
      },
    )}
    aria-current={isSelected}
  >
    <div className='d-flex flex-column mc-h-100 justify-content-between align-items-center'>
      {children}
    </div>
  </div>
)
